import { getClasses, getStudentOnSchoolV2, setClassroomMemberAction } from '@webapps/business';
import {
  Button,
  FormikTextField,
  Loader,
  ModalSideBar,
  PaginationNumbers,
  useAuth,
  useQuery,
  useRouter,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal, { default as ModalStep } from 'components/Modal';
import { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight, Room, Search, Send, Tune } from '@material-ui/icons';
import { useFormik } from 'formik';
import CandidatsCardDetail from './CandidatsCardDetail';
import FiltersStudents from './FiltersStudents';
import InviteStudents from './inviteStudent';
import { ROUTES_PATH } from 'config/constants';
import NewClasses from './NewClasses';
import StudentStatement from '../../ClassesDetail/Components/StudentStatement';
import StatementPeriodModal from '../../ClassesDetail/Components/StatementPeriodModal';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import Nodata from 'components/NoData';
import theme from '../theme';

const ActivityStatement = ({ row, classroom, addAbsence, viewCV }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const {
    images: { Records }
  } = theme

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const intl = useIntl();
  const [filterModal, setFilterModal] = useState(false);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const [openInviteStudents, setOpenInviteStudents] = useState(false);
  const [openCreateClasses, setOpenCreateClasses] = useState(false);
  const [openSetPlanning, setOpenSetPlanning] = useState(false);
  const [idClassCreated, setIdClassCreated] = useState(null);
  const [selectedMember, setSelectedMember] = useState();
  const [viewConfirmDelete, setViewConfirmDelete] = useState(false);
  const [keyword, setKeyword] = useState("");
  const { idUser } = useAuth();
  const { push } = useRouter();
  const { addToast } = useToast();
  // PDF Statement related states
  const [downloadStatement, setDownloadStatement] = useState(false);
  const [student, setStudent] = useState(null);
  const [refStatement, setRefStatement] = useState(useRef(null));
  const [statementPeriod, setStatementPeriod] = useState({
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
  });
  const [periodModalOpen, setPeriodModalOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      keyword: '',
      classes: [],
      training: [],
    },
  });

  // const { data: { content: allClasses = [], totalClasse } = {} } =
  //   useQuery(getClasses, {
  //     key: ['classesHAAAAAA2<QAAAAAAAAAAA', page + idUser],
  //     variables: {
  //       keyword,
  //       id: idUser,
  //       page: page - 1,
  //       size: 12,
  //     },
  //   });

  const { data: { content: students, totalElements } = {}, refetch: refetchStudentsFromSchool, isLoading: isLoadingStudentsFromSchool } = useQuery(getStudentOnSchoolV2, {
    key: ['studentOnSchoolV2', page, formik.values.classes, idUser + formik?.values?.keyword],
    variables: {
      id: idUser,
      page: page - 1,
      classes: formik.values.classes,
      size,
      keyword: formik?.values?.keyword,
      status: 'ENROLLED',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    error: errorMemberClassAction,
    isLoading: isLoadingMemberClassAction,
    isSuccess: isSuccessMemberClassAction,
    mutateAsync: mutateSetMemberClass,
  } = useMutation(setClassroomMemberAction);

  useEffect(() => {
    if (errorMemberClassAction) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessMemberClassAction) {
      addToast({
        status: 'success',
        message: 'Etudiant supprimé avec succès',
      });
      refetchStudentsFromSchool();
      handleCloseViewConfirmDelete();
    }
  }, [isSuccessMemberClassAction, errorMemberClassAction]);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const goToListInviteStudent = () => {
    push(ROUTES_PATH.SCHOOL_INVITE_STUDENT);
  };

  const goToStudentClassHistorique = () => {
    push(ROUTES_PATH.STUDENT_CLASS_HISTORIQUE);
  };

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };

  const handleOpenInviteStudents = () => {
    setOpenInviteStudents(true);
  };

  const handleCloseInviteStudents = () => {
    setOpenInviteStudents(false);
  };

  const handleOpenSetPlanning = () => {
    setOpenSetPlanning(true);
  };

  const handleCloseSetPlanning = () => {
    setOpenSetPlanning(false);
  };

  const handleFilterCVClose = () => {
    setFilterCVOpened(false);
  };

  const handleFilterCVOpen = () => {
    setFilterCVOpened(true);
  };

  const handleSetIdClassCreated = (id) => {
    setIdClassCreated(id);
  };

  const handleDownloadStatement = (student) => {
    setStudent(student);
    setPeriodModalOpen(true);
  };

  const handlePeriodConfirm = (startDate, endDate) => {
    setStatementPeriod({ startDate, endDate });
    setDownloadStatement(true);

    // Wait for next render cycle when StudentStatement is mounted
    setTimeout(() => {
      if (refStatement.current) {
        refStatement.current.downloadPdf();
      }
    }, 0);
  };

  const handleDownloadComplete = () => {
    // Reset states after download is complete
    setDownloadStatement(false);
    setStudent(null);
  };

  const handleOpenViewConfirmDelete = (id) => {
    setSelectedMember(id);
    setViewConfirmDelete(true);
  };

  const handleCloseViewConfirmDelete = () => {
    setViewConfirmDelete(false);
  };

  const deleteOnClass = (id) => {
    mutateSetMemberClass({
      id,
      action: 'exclude',
    });
  };

  return (
    <>
      <div className={classes.containerSearch}>
        <div
          className={css({
            display: 'flex',
            flexWrap: 'wrap',
            gap: spacing(2), // espace entre les éléments, ajustable selon le design
            '@media (max-width: 768px)': {
              flexDirection: 'column', // empiler en colonne pour petits écrans
              width: '100%',
            },
          })}
        >
          <div
            className={
              css({
                display: 'flex',
                gap: spacing(2),
                '@media (max-width:768px)': {
                  width: '100%',
                  backgroundColor: 'red'
                },
                '@media (max-width:768px)': {
                  flexDirection: 'column',
                },
              })
            }
          >
            <div
              className={css({
                flexGrow: 1,
                '@media (max-width:768px)': {
                  flexGrow: 1,
                },
              })}
            >
              <FormikTextField
                formik={formik}
                label="Nom prénom"
                name="keyword"
                size="small"
                variant="outlined"
                endAdornment={<Search style={{ color: '#5D75A8' }} />}
                borderRadius={400}
                fullWidth
              />
            </div>

            <Button
              className={css({
                color: '#5D75A8',
                backgroundColor: '#F3F7FF',
                border: '1px solid #C0D9FF',
                fontWeight: 500,
                display: 'flex',
                justifyContent: 'start',
                '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                '@media only screen and (max-width:1920px)': {
                  fontSize: '13.500px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '13.5000px',
                },
              })}
              color="primary"
              variant="outlined"
              onClick={() => setFilterModal(true)}
            >
              <Tune
                style={{ fontSize: '25px', marginRight: spacing(1), color: '#5D75A8' }}
              />
              <FormattedMessage id="filter" />
            </Button>

          </div>
          <Button
            className={css({
              color: '#5D75A8',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #C0D9FF',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
              '@media only screen and (max-width:1920px)': {
                fontSize: '13.500px',
              },
              '@media only screen and (max-width:1600px)': {
                fontSize: '13.5000px',
              },
            })}
            color="primary"
            variant="outlined"
            onClick={goToListInviteStudent}
          >
            Historique des invitations <ChevronRight />
          </Button>

          <Button
            className={css({
              color: '#5D75A8',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #C0D9FF',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
              '@media only screen and (max-width:1920px)': {
                fontSize: '13.500px',
              },
              '@media only screen and (max-width:1600px)': {
                fontSize: '13.5000px',
              },
            })}
            color="primary"
            variant="outlined"
            onClick={goToStudentClassHistorique}
          >
            Historique des sorties<ChevronRight />
          </Button>

          {/* <Button
            className={css({
              color: '#5D75A8',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #C0D9FF',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
              '@media only screen and (max-width:1920px)': {
                fontSize: '13.500px',
              },
              '@media only screen and (max-width:1600px)': {
                fontSize: '13.5000px',
              },
            })}
            color="primary"
            variant="outlined"
            onClick={() => setAbsenceModalOpen(true)}
          >
            Déclarer une absence
          </Button> */}
          <Button
            className={[classes.button, classes.buttonHover, css({
              display: 'none',
              '@media (max-width:1352px)': {
                display: 'block'
              },
              '@media only screen and (max-width:1920px)': {
                fontSize: '15.00px',
              },
              '@media only screen and (max-width:1600px)': {
                fontSize: '14.00px',
              },
              '@media only screen and (max-width:768px)': {
                flexGrow: 1,
              },
              backgroundColor: 'rgb(192, 217, 255)!important',
            })]}
            color="primary"
            onClick={handleOpenInviteStudents}
            variant="outlined"
            style={{
              border: '1px solid #0060F9',
              fontWeight: 600,
              backgroundColor: 'white',
            }}
          >
            <FormattedMessage id="school.classes.research.invitButton" />
          </Button>

          <Button
            className={[classes.button, css({
              display: 'none',
              '@media (max-width:1352px)': {
                display: 'block'
              },
              '@media only screen and (max-width:1920px)': {
                fontSize: '15.00px',
              },
              '@media only screen and (max-width:1600px)': {
                fontSize: '14.00px',
              },
              '@media only screen and (max-width:768px)': {
                flexGrow: 1,
              },
            })
            ]}
            color="primary"
            onClick={handleOpenCreateClasses}
            variant="contained"
            disableElevation
            style={{
              fontWeight: 600,
            }}
          >
            <FormattedMessage id="school.classes.research.newClassButton" />
          </Button>
        </div>
        <div
          className={
            css({
              display: 'flex',
              gap: spacing(2),
              '@media (max-width:1352px)': {
                display: 'none'
              },
            })
          }
        >
          <div style={{ display: "flex", gap: "16px" }}
            className={
              css({
                '@media (max-width:768px)': {
                  flexDirection: 'column',
                },
              })
            }
          >


            <Button
              className={[classes.button, classes.buttonHover, css({
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
                backgroundColor: 'rgb(192, 217, 255)!important',
              })]}
              color="primary"
              onClick={handleOpenInviteStudents}
              variant="outlined"
              style={{
                border: '1px solid #0060F9',
                fontWeight: 600,
                backgroundColor: 'white',
              }}
            >
              <FormattedMessage id="school.classes.research.invitButton" />
            </Button>

            <Button
              className={[classes.button, css({
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
              })
              ]}
              color="primary"
              onClick={handleOpenCreateClasses}
              variant="contained"
              disableElevation
              style={{
                fontWeight: 600,
              }}
            >
              <FormattedMessage id="school.classes.research.newClassButton" />
            </Button>
          </div>
        </div>
      </div>
      <div className={classes.containerStudents}>
        <div className={classes.students}>

          {
            isLoadingStudentsFromSchool ? (
              [...Array(size/2)].map((_, idx) => (
                <CandidatsCardDetail
                  isLoading={true}
                />
              ))
            ) : students?.length > 0 ? (
              students?.map((item) => {
                return (
                  <CandidatsCardDetail
                    item={item}
                    contactMember={() => contactMember(item?.student?.id)}
                    deleteMember={() => handleOpenViewConfirmDelete(item?.id)}
                    addAbsence={() => addAbsence(item, item?.classroom?.id)}
                    id={item?.student?.id}
                    classId={item?.classroom?.id}
                    viewMember={() => viewCV(item, item?.classroom?.id)}
                    handleDownloadStatement={() => handleDownloadStatement({ ...item?.student, classroom: item?.classroom })}
                    hideAbsence={item?.classroom?.planning == null}
                  />
                )
              })
            ) : (
              <div className={css({ width: '100%', display: 'flex', justifyContent: 'center' })}>
                <Nodata
                  image={Records}
                  contentWidth='70%'
                  padding='0px 20px 20px 0px'
                  title="Aucun apprenant trouvé"
                  description="Affinez vos critères de recherche pour trouver des apprenants."
                />
              </div>
            )
          }
        </div>
      </div>
      <Modal
        onCancel={() => setOpenSetPlanning(false)}
        open={openSetPlanning}
        title="Créer le planning de la classe"
      >
        <div className={classes.copyToClipboardContainer}>
          <div className={cx(global.subTitle, classes.subTitle)}>Votre classe a été créée avec succès</div>
          <div className={cx(global.subTitle, classes.subTitle)}>Vous pouvez maintenant créer le planning de la classe</div>
          <Button
            className={css({ borderRadius: '6px' })}
            color="primary"
            onClick={() => {
              // IL Y A 2 ?? CAR LA REQUETE EN ENLEVE 1, DONC QUAND ON MET 2, ON A 1
              // C'EST CHELOU MAIS CA MARCHE !
              push(`${ROUTES_PATH.SCHOOL_CLASSES_DETAIL}??planning=true`, { params: { id: idClassCreated } });
            }}
            variant="contained"
          >
            Créer le planning
          </Button>
          <Button
            className={css({ borderRadius: '6px' })}
            color="primary"
            onClick={() => {
              handleCloseSetPlanning()
            }}
            variant="outlined"
          >
            Plus tard
          </Button>

        </div>
      </Modal>
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title={intl.formatMessage({
          id: 'school.createClasse.title',
        })}
        withStep={false}
      >
        <NewClasses close={handleCloseCreateClasses} refetch={() => refetchStudentsFromSchool()}
          handleOpenSetPlanning={handleOpenSetPlanning} handleSetIdClassCreated={handleSetIdClassCreated}
        />
      </Modal>
      <ModalSideBar
        handleClose={() => setFilterModal(false)}
        open={filterModal}
        title="Filtres"
        width="400px"
      >
        <FiltersStudents formik={formik} />
      </ModalSideBar>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={() => deleteOnClass(selectedMember)}
        isLoading={isLoadingMemberClassAction}
        onClose={handleCloseViewConfirmDelete}
        open={viewConfirmDelete}
        title="Supprimer de la classe"
      >
        Êtes-vous sûr de vouloir supprimer l'étudiant de la classe
      </ModalConfirm>
      <ModalStep
        onCancel={handleCloseInviteStudents}
        open={openInviteStudents}
        title={intl.formatMessage({
          id: 'school.classes.invite.title',
        })}
        withStep={false}
      >
        <InviteStudents close={handleCloseInviteStudents} />
      </ModalStep>
      {students?.length > 0 && (
        <PaginationNumbers
          onChange={handlePaginationChange}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      )}

      {/* PDF Statement related components */}
      {downloadStatement && (
        <StudentStatement
          ref={refStatement}
          student={student}
          startDate={statementPeriod.startDate}
          endDate={statementPeriod.endDate}
          onDownloadComplete={handleDownloadComplete}
        />
      )}

      <StatementPeriodModal
        open={periodModalOpen}
        onClose={() => setPeriodModalOpen(false)}
        onConfirm={handlePeriodConfirm}
      />
    </>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background: 'white',
    padding: 20,
    height: '100%',
    borderRadius: '0 10px 10px 10px',
  },
  divStudent: {
    display: 'flex',
    width: '100%',
  },
  nameAndCity: {
    marginLeft: spacing(1),
  },
  containerSearch: {
    background: 'white',
    paddingBottom: '20px',
    borderRadius: '0 10px 10px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacing(2),
  },
  containerStudents: {
    background: 'white',
    height: '100%',
    borderRadius: '0 10px 10px 10px',
  },
  students: {
    backgroundColor: '#F3F7FF',
    borderRadius: 10,
    padding: spacing(0, 0, 2.5, 2.5),
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonHover: {
    "&:hover": {
      backgroundColor: "#0060F9!important",
      color: "white!important",
    },
  },
});

export default ActivityStatement;
